/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const E = 500, I = 768;
export {
  I as MOBILE_MEDIUM_DEVISE,
  E as MOBILE_SMALL_DEVISE
};
